import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist/dist/umd';
import Permissions from '@/objects/Permissions';

//----------------------------------
// Vuex Store Definition
//----------------------------------
const vuexPersist = new VuexPersist({
  key: 'sav',
  storage: localStorage,
});

Vue.use(Vuex);
const store = new Vuex.Store({
  plugins: [vuexPersist.plugin],
  state: {
    auth: null,
    stsid: null,
    skey: null,
    permissions: null,
    role: null,
    name: null,
    extras: null,
    uuid: null,
    branch: null,
    hash: null,
    versionCheck: null,
  },
  getters: {
    auth(state) {
      return state.auth;
    },
    stsid(state) {
      return state.stsid;
    },
    skey(state) {
      return state.skey;
    },
    permissions(state) {
      return state.permissions;
    },
    role(state) {
      return state.role;
    },
    name(state) {
      return state.name;
    },
    extras(state) {
      return state.extras;
    },
    uuid(state) {
      return state.uuid;
    },
    branch(state) {
      return state.branch;
    },
    hash(state) {
      return state.hash;
    },
    versionCheck(state) {
      return state.versionCheck;
    },
  },
  mutations: {
    auth(state, value) {
      state.auth = value;
    },
    stsid(state, value) {
      state.stsid = value;
    },
    skey(state, value) {
      state.skey = value;
    },
    permissions(state, value) {
      state.permissions = value;
    },
    role(state, value) {
      state.role = value;
    },
    name(state, value) {
      state.name = value;
    },
    extras(state, value) {
      state.extras = value;
    },
    uuid(state, value) {
      state.uuid = value;
    },
    branch(state, value) {
      state.branch = value;
    },
    hash(state, value) {
      state.hash = value;
    },
    versionCheck(state, value) {
      state.versionCheck = value;
    },
  },
});
export default store;

//----------------------------------
// Exposed Store Definition
//----------------------------------

export class Store {
  //----------------------------------
  // Public Properties
  //----------------------------------
  static get auth() {
    return store.getters.auth;
  }

  static set auth(value) {
    try {
      const [, auth, stsid] = value.split(' ');
      store.commit('auth', auth);
      if (stsid) {
        store.commit('stsid', stsid);
      }
    } catch (err) {
      store.commit('auth', null);
      store.commit('stsid', null);
    }
  }

  static get stsid() {
    return store.getters.stsid;
  }

  static set skey(value) {
    store.commit('skey', value);
  }

  static get skey() {
    return store.getters.skey;
  }

  /** @returns {Permissions} */
  static get permissions() {
    return store.getters.permissions;
  }

  static set permissions(value) {
    store.commit('permissions', new Permissions(value));
  }

  static get role() {
    return store.getters.role;
  }

  static set role(value) {
    store.commit('role', value);
  }

  static get name() {
    return store.getters.name;
  }

  static set name(value) {
    store.commit('name', value);
  }

  static get extras() {
    return store.getters.extras;
  }

  static set extras(value) {
    store.commit('extras', value);
  }

  static get uuid() {
    return store.getters.uuid;
  }

  static set uuid(value) {
    store.commit('uuid', value);
  }

  static get branch() {
    return store.getters.branch;
  }

  static set branch(value) {
    store.commit('branch', value);
  }

  static get hash() {
    return store.getters.hash;
  }

  static set hash(value) {
    store.commit('hash', value);
  }

  static get versionCheck() {
    return store.getters.versionCheck;
  }

  static set versionCheck(value) {
    store.commit('versionCheck', value);
  }

  //----------------------------------
  // Public Methods
  //----------------------------------
  static clear() {
    store.commit('auth', null);
    store.commit('stsid', null);
    store.commit('skey', null);
    store.commit('permissions', null);
    store.commit('role', null);
    store.commit('name', null);
    store.commit('extras', null);
    store.commit('uuid', null);
    store.commit('branch', null);
  }
}
